<template>
  <el-dialog title="拼接地图" :visible.sync="showDialog" width="800px" class="mydialog" :append-to-body="true"
    @close="handleClose">
    <el-row>
      <el-col :span="4">任务名称</el-col>
      <el-col :span="20">
        <el-input clearable style="width: 300px;" v-model="info.name"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">图源名称</el-col>
      <el-col :span="20" style="font-weight: bold;">
        {{ info.mapSourceName }}
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">坐标信息</el-col>
      <el-col :span="20">
        <span style="display: block;">
          {{ leftTopStr }}
          &emsp;{{ rightBottomStr }}
        </span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">基本信息</el-col>
      <el-col :span="20">
        <span v-html="info.info"></span>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">拼接层级</el-col>
      <el-col :span="20">
        <el-input-number v-model="info.zoom" :min="1" :max="20" label="描述文字" style="width: 150px;"></el-input-number>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="4">预计大小</el-col>
      <el-col :span="20">
        大约需要下载 <b>{{ totalTileSize }}</b> 片地图，分辨率 <b>{{ picResolution }} </b>
      </el-col>
    </el-row>

    <!-- <el-row>
      <el-col :span="4">叠加网格</el-col>
      <el-col :span="20">
        <el-select v-model="info.grid" placeholder="请选择" style="width: 150px;" @change="gridChange()">
          <el-option v-for="(item, index) in ['无', '经纬网', '高斯网']" :key="index" :label="item" :value="index">
          </el-option>
        </el-select>
        <span><span style="color: red;">*</span>&emsp;高斯网为CGCS2000椭球体下的平面投影，仅在大于13级时叠加</span>
      </el-col>
    </el-row>
    <el-row v-show="info.grid != 0">
      <el-col :span="4">网格颜色</el-col>
      <el-col :span="20">
        <el-color-picker v-model="info.gridColor" size="mini" style="vertical-align: middle;">
        </el-color-picker>
      </el-col>
    </el-row>

   <el-row v-show="info.grid != 0">
      <el-col :span="4">网格粗细</el-col>
      <el-col :span="20">
        <el-input-number v-model="info.gridWidth" :min="1" :max="10" label="网格粗细" size="mini"></el-input-number>
      </el-col>
    </el-row>  -->


    <span slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false">取消</el-button>
      <el-button type="primary" @click="splice">开始拼接</el-button>
    </span>
  </el-dialog>

</template>

<script>
import geoUtil from '@/util/geoUtil.js'
import { splice } from '../../util/request'
import { InfiniteScroll } from 'element-ui';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: {
        leftTop: null, rightBottom: null,
        grid: 0,
        gridColor: '#000000',
        zoom: 15,
        gridWidth:2
      }
    }
  },
  data() {
    return {
      showDialog: false,
    };
  },
  watch: {
    show: function (n, o) {
      this.showDialog = n
    }
  },
  computed: {
    picResolution() {
      if (this.info.leftTop == null || this.info.rightBottom == 0) {
        return 0
      }
      return geoUtil.getPicResolution(this.info.leftTop, this.info.rightBottom, this.info.zoom)
    },
    totalTileSize() {
      if (this.info.leftTop == null || this.info.rightBottom == 0) {
        return 0
      }
      return geoUtil.calcTotalTileSize(this.info.leftTop, this.info.rightBottom, this.info.zoom)
    },
    leftTopStr() {
      return geoUtil.formatLatlng(this.info.leftTop)
    },
    rightBottomStr() {
      return geoUtil.formatLatlng(this.info.rightBottom)
    }
  },
  methods: {
    handleClose() {
      // 给父元素传值，关闭对话框
      this.$emit('update:show', false)
    },
    splice() {
      if (this.totalTileSize > 1000) {
        this.$message.error('大于1000块将会提高受网速影响的不确定性，建议进行分割下载！')
        return;
      }
      if (!this.$store.getters.vipIsAvailable) {
        if (this.totalTileSize > 100) {
          this.$message.error('非vip用户只能拼接小于100张瓦片')
          return
        } else
          this.$confirm('非vip用户只能拼接小于100张瓦片且带有水印', '已知晓', { type: 'success', title: '提示' }).then(() => {
            //正常提交任务
            splice(this.info).then(res => {
              if (res.resultCode == 1) {
                let taskId = res.result
                this.$message.success(`任务 ${taskId} 添加成功...`)
                this.$store.commit('addTask', taskId)
                this.showDialog = false
              } else
                this.$message.error(res.result)
            })
          })
      } else {
        //正常提交任务
        splice(this.info).then(res => {
          if (res.resultCode == 1) {
                let taskId = res.result
                this.$message.success(`任务 ${taskId} 添加成功...`)
                this.$store.commit('addTask', taskId)
                this.showDialog = false
              } else
                this.$message.error(res.result)
        })
      }
    },
    gridChange() {
      console.log(this.info);
      if (this.info.grid == 2 && this.info.level < 13) {
        this.$message.error("高斯坐标网仅在大于13级的情况下才会添加，请调整下载层级或者是下载区域范围！");
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}

.el-col {
  height: 50px;
  line-height: 50px;
}

.title {
  text-align: right;
  padding-right: 10px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/main/SpliceDialog.vue